const initMenu = () =>{
  const ham = document.getElementById('hamburger');
  const nav = document.getElementsByTagName('nav')[0];
  const cartBtn = document.getElementsByClassName('cart-btn');
  const cartClose = document.getElementById('close-cart');
  const opacity = document.getElementById('opacity');
  const loginBtn = document.getElementsByClassName('login-btn--login');
  const loginModal = document.getElementById('login');
  const loginModalClose = document.getElementById('close-login');

  opacity.addEventListener('click', () =>{
    closeCart();
    opacity.classList.remove('active');
    loginModal.classList.add('hidden');
  })
  
  ham.addEventListener('click',function(){
    toggleMenu(nav);
  });
  for(c of cartBtn){
    c.addEventListener('click',openCart);
  }
  // cartClose.addEventListener('click',closeCart);
  
  for(let l of loginBtn){
    l.addEventListener('click', () =>{
      opacity.classList.add('active');
      loginModal.classList.remove('hidden');
      document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
    })
  }
  
  // loginModalClose.addEventListener('click', () =>{
  //   opacity.classList.remove('active');
  //   loginModal.classList.add('hidden');
  //   document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
  // })
}

const openCart = () =>{
  document.getElementById('cart-ajax').classList.remove('close');
  document.getElementById('opacity').classList.add('active');
  document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
}

const closeCart = () =>{
  document.getElementById('cart-ajax').classList.add('close');
  document.getElementById('opacity').classList.remove('active');
  document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
}

const toggleMenu = (nav) =>{
  nav.classList.toggle('open');
  document.getElementsByClassName('menu')[0].classList.toggle('open');
  if(nav.classList.contains('open')){
    document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
  }else{
    document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
  }
  
}

$(document).ready(initMenu);